import React from 'react';
class NotFound extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
            
        }
	}

	componentDidMount() {
	}

	render() {
		return(
			<React.Fragment>
				<main role="main" className="middle-content-area">
					<section className="contact-area mt-4">
						<div className="row">
							<div className="col-md-12">
							<div className="default-title">
								<div className="row">
								<div className="col-md-6">
									<h1 className="m-0 color1"> </h1>
								</div>
								</div>
							</div>

							</div>
						</div>
						<div className="row">
							<div className="col-md-12 text-center mt-5">
								<h1>404 - Page Not Found</h1>
                                <p>The page you’re looking for doesn’t exist.</p>
							
							</div>
						</div>
					</section>	
				</main>
			</React.Fragment>
		)
	}

}

export default NotFound;